/**
 * Created by Jerker Nord on 2019-09-02.
 */
import {
    IStillImageBackgroundConfig,
    StillImageBackground
} from "@nolimitcity/slot-game/bin/game/background/StillImageBackground";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {IResizeData} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {IGameModeChangedData} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";

export class MonkeysGoldBackground extends StillImageBackground {

    public static monkeysGoldBackground:MonkeysGoldBackground;
    private static readonly DEFAULT_OFFSET:PIXI.Point = new PIXI.Point(0, 0);

    private _waterFallRight:PIXI.spine.Spine;
    private _waterFallLeft:PIXI.spine.Spine;
    private _pond:PIXI.spine.Spine;

    constructor(config:IStillImageBackgroundConfig) {
        super(config);
        MonkeysGoldBackground.monkeysGoldBackground = this;
    }

    protected initAnimations():void {
        super.initAnimations();
        this._waterFallRight = new PIXI.spine.Spine(GameResources.getSpineAsset("spineWaterfall"));
        this._layer.addChild(this._waterFallRight);
        this._waterFallRight.position.set(510, 798);
        this._waterFallRight.state.setAnimation(0, "water_fall_animation", true);

        this._waterFallLeft = new PIXI.spine.Spine(GameResources.getSpineAsset("spineWaterfall"));
        this._waterFallLeft.skeleton.scaleX = -1
        this._layer.addChild(this._waterFallLeft);
        this._waterFallLeft.position.set(206, 798);
        this._waterFallLeft.state.setAnimation(0, "water_fall_animation", true);

        this._pond = new PIXI.spine.Spine(GameResources.getSpineAsset("spinePond"));
        this._pond.skeleton.scaleX = 2;
        this._pond.skeleton.scaleY = 2;
        this._layer.addChild(this._pond);
        this._pond.position.set(360, 1020);
        this._pond.state.setAnimation(0, "animation", true);
    }

    protected onResize(resizeData:IResizeData) {
        if(resizeData.orientation == Orientation.LANDSCAPE) {
            this._waterFallLeft.visible = false;
            this._waterFallRight.visible = false;
            this._pond.visible = false;
        } else {
            this._waterFallLeft.updateTransform();
            this._waterFallLeft.visible = true;
            this._waterFallRight.updateTransform();
            this._waterFallRight.visible = true;
            this._pond.updateTransform();
            this._pond.visible = true;
        }
    }

    public changeBackground(data:IGameModeChangedData):void{
        this.onChangeBackground(data);
    }
}